module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field tag-list"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.labelText) + " "), (!_vm.required) ? _c('em', {
    staticClass: "optional"
  }, [_vm._v("optional")]) : _vm._e(), (_vm.required) ? _c('em', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tag-list--input"
  }, [_c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tag),
      expression: "tag"
    }],
    class: _vm.getClass(),
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "id": _vm.name,
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.tag)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.addOrRemoveTag($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.addTagKey($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "comma", undefined, $event.key, undefined)) { return null; }
        return _vm.addTagKey($event)
      }],
      "focus": _vm.emitFocus,
      "blur": _vm.emitBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tag = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "add icon yule-icon-circle-plus",
    on: {
      "click": _vm.addOrRemoveTag
    }
  })]), _vm._v(" "), _vm._l((_vm.value), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tag-list--item"
    }, [_c('span', [_vm._v(_vm._s(item.length > 15 ? ((item.slice(0, 15)) + "…") : item))]), _vm._v(" "), (!_vm.isProtected(item)) ? _c('i', {
      staticClass: "icon tag-list--icon remove yule-icon-close-small",
      on: {
        "click": function($event) {
          return _vm.removeTag(index)
        }
      }
    }) : _c('i', {
      staticClass: "icon tag-list--icon yule-icon-lock"
    })])
  })], 2), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t(_vm.error)))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8eeaf86a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/TagList.vue
// module id = 1963
// module chunks = 0